import * as React from 'react';
import {MenuItemContainer} from '../../system/menu';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {ActionLink, Secondary} from '../../system/buttons';
import {Marketplace} from './Marketplace';
import Card from 'react-bootstrap/Card';
import {CardGroup} from 'react-bootstrap';
import {resolveIntegrationLogo} from './utils';
import PulsoidClient from '../../PulsoidClient';
import {LoaderWrapperLazy} from '../../system/Loader/Loader';
import {processClients} from './ClientCard';
import {DASHBOARD_ROUTES} from '../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../navigation/navigationUtils';
import {HeadTitle} from '../../system/HeadTitle';

export class WebHooks extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.client = new PulsoidClient();
  }

  initWebHooks = () => {
    this.setState({integrations: undefined});
    return this.client
      .getAllWebHooks()
      .then((integrations) => this.setState({integrations}));
  };
  initConnectedClients = () => {
    this.setState({connectedClients: undefined});
    return this.client
      .getConnectedClients()
      .then((connectedClients) => this.setState({connectedClients}));
  };

  componentDidMount() {
    this.initConnectedClients();
    this.initWebHooks();
  }

  render() {
    let integrationCards = [];
    if (this.state.integrations) {
      integrationCards = this.state.integrations.map((e, index) => {
        return (
          <Card
            id={e.id}
            style={{
              width: '15rem',
              height: '15rem',
              margin: '5px',
              border: '1px solid rgba(0,0,0,.125)',
            }}
            className="text-center"
            key={index}
          >
            <Card.Body style={{height: '100%', textAlign: 'center'}}>
              <Card.Subtitle className="mb-2">{e.name}</Card.Subtitle>
              <Card.Subtitle style={{fontSize: '10px'}}>
                {e.description}
              </Card.Subtitle>
              <div style={{height: '8em'}}>
                {resolveIntegrationLogo(e.metaId)}
              </div>

              <Row>
                <Col xs={5}>
                  <ActionLink
                    to={buildRoute({
                      path: DASHBOARD_ROUTES.INTEGRATIONS_EDIT,
                      params: {id: e.id},
                    })}
                  >
                    Configure
                  </ActionLink>
                </Col>
                <Col xs={1} />
                <Col xs={5}>
                  <Secondary
                    onClick={async () => {
                      await this.client.deleteWebHook(e.id);
                      await this.initWebHooks();
                    }}
                    variant="dark"
                  >
                    Delete
                  </Secondary>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        );
      });
    }

    let connectedClientsCard = [];
    if (this.state.connectedClients) {
      connectedClientsCard = processClients(
        this.state.connectedClients,
        this.initConnectedClients
      );
    }

    let allCards = integrationCards.concat(connectedClientsCard);

    return (
      <MenuItemContainer title={'Integrations'}>
        <HeadTitle title={'Integrations'} />

        <div style={{padding: '10px', width: '900px'}}>
          <h3 style={{paddingLeft: '10px'}}>My integrations</h3>
          <hr />

          <LoaderWrapperLazy
            loading={!this.state.integrations}
            lazyChildren={() =>
              this.groupByThree(allCards).map((value, index) => (
                <CardGroup key={index}>{value}</CardGroup>
              ))
            }
          />
          <br />
          <h3 style={{paddingLeft: '10px'}}> Marketplace</h3>
          <hr />
          <Marketplace onNewWebHook={() => this.initWebHooks()} />
        </div>
      </MenuItemContainer>
    );
  }

  emptyCard = (key) => {
    return (
      <Card
        style={{
          width: '18rem',
          height: '10rem',
          margin: '5px',
          border: '1px solid white',
        }}
        key={key}
      ></Card>
    );
  };

  groupByThree = (array) => {
    let metaArray = [];
    let innerArray = [];
    let first = true;
    array.forEach((value, index) => {
      if (index % 3 === 0) {
        if (first) {
          innerArray.push(value);
          first = false;
        } else {
          metaArray.push(innerArray);
          innerArray = [value];
        }
      } else {
        innerArray.push(value);
      }
    });

    let count = 3 - innerArray.length;
    for (var i = 1; i <= count; i++) {
      innerArray.push(this.emptyCard(innerArray.length + i));
    }
    metaArray.push(innerArray);

    return metaArray;
  };
}
